export default __webpack_public_path__ + "static/media/image.discover-lk.8032b469.png";